import i18n, { TOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import { en, pl } from './resources';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: 'postProcessor',
    name: 'interval',
    process: (value: string, key: string[], options: TOptions, translator: any) => {
      let parsedOptions = options;

      if (options.lng === 'pl' && !parsedOptions.omitCountParsing) {
        const count = parsedOptions.count || 0;
        parsedOptions = {
          ...parsedOptions,
          count: count > 21 ? Number(count.toString().slice(-1)) : options.count,
        };
      }
      return intervalPlural.process(value, key, parsedOptions, translator);
    },
  })
  .init({
    fallbackLng: 'pl',
    interpolation: {
      defaultVariables: { specialChar: '' },
    },
    resources: {
      pl,
      en,
    },
  });

export default i18n;
